<ng-container *ngIf="!statuses">
  <ng-container *ngIf="state$ | async as state">
    <ng-container *ngIf="!workflow; else workflowTemplate">
      <button
        *appHasPermission="'authorization.view'"
        mat-icon-button
        [matTooltip]="'icons.authorizations.tooltip' | translate: { status: state.tooltipText | translate }"
        matTooltipPosition="above"
        [matMenuTriggerFor]="authorizationMenu"
        [disabled]="!appointment"
        (click)="fetchAuths($event)"
      >
        <mat-progress-spinner
          *ngIf="inProgress"
          diameter="30"
          mode="indeterminate"
        ></mat-progress-spinner>
        <div class="icon-container">
          <mmx-overlap-icon
            *ngIf="state.statuses"
            [primaryColor]="state.statuses.primary"
            [secondaryColor]="state.statuses.secondary"
            icon="lock"
          ></mmx-overlap-icon>
        </div>
      </button>

      <mat-menu #authorizationMenu="matMenu">
        <div fxLayoutAlign="center center">
          <mat-progress-spinner
            *ngIf="isLoadingAuths | async"
            diameter="30"
            mode="indeterminate"
          ></mat-progress-spinner>
        </div>
        <button mat-menu-item *ngFor="let auth of appointmentAuths | async" (click)="openConfirmDialog(auth)">
          {{getInsurance(auth.carrierLookupId)?.clinicCarrierName}}
          <div fxLayoutAlign="end center">
            <i>{{auth.createdAt | date}}</i>
          </div>
        </button>
        <button mat-menu-item (click)="openConfirmDialog()">
          <mat-icon>add</mat-icon>
          {{ 'patient-details.authorization-card.button-add' | translate }}
        </button>
        <!-- <button
          *ngFor="let item of state.insuranceItems"
          mat-menu-item
          (click)="openConfirmDialog(item.insurance, item.status)"
        >
          <mat-icon
            class="primary-icon"
            style="min-width: 23px"
            [ngClass]="item.statusColor"
          >
            person_add
          </mat-icon>
          {{ item.insurance.typeText | translate }} - {{ item.insurance.clinicCarrierName }}
          ({{ (item.status ? 'statuses.authorizations.' + item.status : 'common.unknown') | translate }})
        </button> -->
      </mat-menu>
    </ng-container>
    <ng-template #workflowTemplate>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <mmx-overlap-icon
          *ngIf="state.statuses"
          [primaryColor]="state.statuses.primary"
          [secondaryColor]="state.statuses.secondary"
          icon="lock"
          fxFlex="25px"
        ></mmx-overlap-icon>
        <span>{{
          'icons.authorizations.tooltip'
            | translate: { status: state.tooltipText | translate }
        }}</span>
      </div>
    </ng-template>
  </ng-container>
</ng-container>

<button *ngIf="statuses" mat-stroked-button>
  <mat-icon [ngClass]="getAuthorizationStatusColor(statuses[0])">
    lock
  </mat-icon>
  {{ getAuthorizationStatusText(statuses[0]) | translate }}
</button>
